import {RouterModule, Routes} from '@angular/router';
import {ModuleWithProviders} from '@angular/core';
import {AuthComponent} from './core/auth';
import {SwaggerComponent} from './swagger.component';

export const routes: Routes = [
    { path: 'login', component: AuthComponent, data: { title: 'Login' }, runGuardsAndResolvers: 'always' },
    { path: '', redirectTo: '/project/list', pathMatch: 'full' },
    { path: 'swagger', component: SwaggerComponent, data: { title: 'Api Documentation'} }
];

export const AppRoutes: ModuleWithProviders = RouterModule.forRoot(routes,
    { scrollPositionRestoration: 'enabled', onSameUrlNavigation: 'reload'}
);
